import {
    displayCurrencyOrDashTruthyZero,
    displayPercentOrNaTruthyZero,
    displayShortDateOrNA
} from '../../utils/Format/Format';

export const priceUtil = (ticker) => (gqlResult) => {
    if (!gqlResult) return null;

    const {
        exchangeTradedFund: {
            price: {
                asOfDate: displayDate,
                navFiftyTwoWeekHigh,
                navFiftyTwoWeekLow,
                bidAskSpreadMonthlyMedian,
                closingPriceFiftyTwoWeekHigh,
                closingPriceFiftyTwoWeekLow
            }
        }
    } = gqlResult;
    const asOfDate = displayShortDateOrNA(displayDate);

    const returnData = [
        {
            label: ``,
            values: [{ val1: `Market Price` }, { val2: `NAV` }]
        },
        {
            label: `52 Week High`,
            values: [
                {
                    val1: displayCurrencyOrDashTruthyZero(
                        closingPriceFiftyTwoWeekHigh
                    )
                },
                { val2: displayCurrencyOrDashTruthyZero(navFiftyTwoWeekHigh) }
            ]
        },
        {
            label: `52 Week Low`,
            values: [
                {
                    val1: displayCurrencyOrDashTruthyZero(
                        closingPriceFiftyTwoWeekLow
                    )
                },
                { val2: displayCurrencyOrDashTruthyZero(navFiftyTwoWeekLow) }
            ]
        },
        {
            label: ``,
            values: [{ val1: `` }, { val2: `ETF` }]
        },
        {
            label: `30 Day Median Bid/Ask Spread`,
            values: [
                { val1: `` },
                {
                    val2: `${displayPercentOrNaTruthyZero(
                        bidAskSpreadMonthlyMedian
                    )}`
                }
            ]
        }
    ];

    return {
        data: returnData,
        asOfDate,
        ticker
    };
};
